
import React, { useState } from "react";

// Icons
import * as AiIcons from "react-icons/ai";
import { Badge, Button, Modal, Stack } from "react-bootstrap";
import ModalEdit from "../../components/ModalEdit";
import NewShortLink from "./_NewShortLinks";
import Confirm from "../../components/Confirm";
import EditBitlyToken from "../Generic/_EditBitlyToken";
import ShortLinkDetail from "./_ShortLinkDetail";
import { Table } from "../../components/ui/Table";
import { useGetShortLinks } from "../../features/shortlinks/hooks/useGetShortLinks";
import { useChangeStatusShortLink } from "../../features/shortlinks/hooks/useChangeStatusShortLink";
const ShortLinks = () => {
  const {
    data: listShortLinks = [],
    isPending: isLoading,
    refetch: getShortLinks,
  } = useGetShortLinks();
  const { mutate: changeStatusShortLink } =
    useChangeStatusShortLink(getShortLinks);

  const [show, setShow] = useState(false);

  const modalMessage = "¿Desea cambiar el estatus del registro?";
  const [modalShowConfirm, setModalShowConfirm] = useState(false);
  const [showEditConfig, setShowEditConfig] = useState(false);
  const [showDetailUrl, setShowDetailUrl] = useState(false); /*******/
  const [idRecordToInactivate, setIdRecordToInactivate] = useState(false);

  const [ShortLink, setShortLink] = useState(null);
  const [OriginalLink, setOriginalLink] = useState(null);
  const [shortLinkFull, setShortLinkFull] = useState(null);
  const [ShortLinkName, setShortLinkName] = useState(null);
  const handleClose = () => {
    getShortLinks();
    setShowDetailUrl(false);
    setShow(false);
  };

  const handleShow = () => setShow(true);
  const ModalHandleClose = () => setModalShowConfirm(false);
  const handleCloseEditConfig = () => setShowEditConfig(false);
  const handleConfirm = () => {
    changeStatusShortLink({ idRecordToInactivate });
    setModalShowConfirm(false);
  };

  const handleShowDetailUrl = () => setShowDetailUrl(true); /*******/

  const columns = [
    {
      accessor: "displayname",
      Header: "Nombre",
    },
    {
      accessor: "shortlinks",
      Header: "Url Corta",
      Cell: (rowData) => {
        let rowInfo = rowData.row.original;
        return (
          <>
            {rowInfo.shortlinks}{" "}
            <a
              href={rowInfo.shortlinks}
              className="LinkBlue"
              target="_blank"
              rel="noreferrer"
            >
              <AiIcons.AiOutlineLink />
            </a>
          </>
        );
      },
    },
    {
      accessor: "originallink",
      Header: "Url Original",
      Cell: (rowData) => {
        let rowInfo = rowData.row.original.originallink;
        return (
          <>
            {rowInfo.length > 50 ? rowInfo.substring(0, 49) + "..." : rowInfo}{" "}
            <a
              href={rowInfo}
              className="LinkBlue"
              target="_blank"
              rel="noreferrer"
            >
              <AiIcons.AiOutlineLink />
            </a>
          </>
        );
      },
    },
    {
      accessor: "active",
      Header: "Estatus",
      Cell: (rowData) => {
        let active = rowData.row.original.active;
        return (
          <>
            {active ? (
              <Badge bg="primary">Activo</Badge>
            ) : (
              <Badge bg="secondary">Inactivo</Badge>
            )}
          </>
        );
      },
    },
    {
      accessor: "none",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center",
      },
      cellProps: {
        className: "text-center",
      },
      Cell: (rowData) => {
        let idshortlink = rowData.row.original.idshortlink;
        let bitlink = rowData.row.original.bitlink;
        let bitlinkName = rowData.row.original.displayname;
        let shortlinks = rowData.row.original.shortlinks;
        let Longlink = rowData.row.original.originallink;
        return (
          <>
            <AiIcons.AiOutlineEyeInvisible
              className="IconTable"
              title="Desactivar"
              onClick={() => {
                setIdRecordToInactivate(idshortlink);
                setModalShowConfirm(true);
              }}
            />
            |
            <AiIcons.AiOutlineSearch
              className="IconTable"
              title="Detalles"
              onClick={() => {
                setShowDetailUrl(true);
                setShortLink(bitlink);
                setShortLinkName(bitlinkName);
                setOriginalLink(Longlink);
                setShortLinkFull(shortlinks);
              }}
            />{" "}
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className="">
        <Stack direction="horizontal" gap={2}>
          <div>
            <h2>Urls Cortas</h2>
            <h3>Administre la lista de Urls Cortas.</h3>
          </div>
          <div className="ms-auto">
            {/* <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShowEditConfig(true);
              }}
            >
              <AiIcons.AiFillSetting /> Token BitLy
            </Button>  */}
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShow(true);
              }}
            >
              <AiIcons.AiOutlinePlus /> Agregar
            </Button>
          </div>
        </Stack>

        <div className="bg-white px-4 py-2 rounded-lg">
          <Table
            columns={columns}
            data={listShortLinks}
            config={{
              search: true,
              pagination: true,
              pageSize: 10,
              perPage: 10,
              footer: true,
            }}
            loading={isLoading}
          />
        </div>
      </div>
      <ModalEdit
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        title="Editando Url Corta"
      >
        <NewShortLink
          handleShow={handleShow}
          handleClose={handleClose}
        ></NewShortLink>
      </ModalEdit>
      {showDetailUrl && (
        <Modal
          show={showDetailUrl}
          handleShow={handleShowDetailUrl}
          onHide={handleClose}
          placement="start"
          size="lg"
          fullscreen={"xl-down"}
        >
          <Modal.Header>
            <Modal.Title>Detalles de la Url Corta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ShortLinkDetail
              ShortLink={ShortLink}
              ShortLinkName={ShortLinkName}
              OriginalLink={OriginalLink}
              ShortLinkFull={shortLinkFull}
            ></ShortLinkDetail>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {showEditConfig && (
        <ModalEdit
          show={showEditConfig}
          handleClose={handleCloseEditConfig}
          title="Modificar Token Bitly"
        >
          <EditBitlyToken handleClose={handleCloseEditConfig}></EditBitlyToken>
        </ModalEdit>
      )}

      <Confirm
        show={modalShowConfirm}
        handleClose={ModalHandleClose}
        handleConfirm={handleConfirm}
        message={modalMessage}
      />
    </>
  );
};

export default ShortLinks;
